import { Suspense } from "react";
import { AuthProvider } from "common/providers/AuthProvider";
import { LoadingProvider } from "common/providers/LoadingProvider";
import { AlertsProvider } from "common/providers/alerts";
import { OrganizationProvider } from "common/providers/OrganizationProvider";
import { CourseProvider } from "common/providers/CourseProvider";
// import { NotificationProvider } from 'common/providers/NotificationProvider';

type Props = {
  children: JSX.Element;
};

function AppProvider({ children }: Props) {
  return (
    <Suspense>
      <LoadingProvider>
        <AlertsProvider>
          <AuthProvider>
            <OrganizationProvider>
              <CourseProvider>{children}</CourseProvider>
            </OrganizationProvider>
          </AuthProvider>
        </AlertsProvider>
      </LoadingProvider>
    </Suspense>
  );
}

export default AppProvider;
